import { render, staticRenderFns } from "./CourseWorkExamPreview.vue?vue&type=template&id=4356e438&"
import script from "./CourseWorkExamPreview.vue?vue&type=script&lang=js&"
export * from "./CourseWorkExamPreview.vue?vue&type=script&lang=js&"
import style0 from "./CourseWorkExamPreview.vue?vue&type=style&index=0&id=4356e438&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports